import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - accounts
const AccountsPage = Loadable(lazy(() => import('pages/accounts/')));
const AccountForm = Loadable(lazy(() => import('pages/accounts/AccountForm')));
const AccountView = Loadable(lazy(() => import('pages/accounts/AccountView')));

// render - tenants
const TenantsPage = Loadable(lazy(() => import('pages/tenants/')));
const TenantForm = Loadable(lazy(() => import('pages/tenants/TenantForm')));
const TenantView = Loadable(lazy(() => import('pages/tenants/TenantView')));

// render - users
const UsersPage = Loadable(lazy(() => import('pages/users')));
const UserForm = Loadable(lazy(() => import('pages/users/UserForm')));
const UserView = Loadable(lazy(() => import('pages/users/UserView')));

// render - projects
const ProjectsPage = Loadable(lazy(() => import('pages/projects')));
const ProjectForm = Loadable(lazy(() => import('pages/projects/ProjectForm')));
const ProjectView = Loadable(lazy(() => import('pages/projects/ProjectView')));

// render - tests
const TestsPage = Loadable(lazy(() => import('pages/tests')));

// render - CMS
const CMSPage = Loadable(lazy(() => import('pages/CMS')));
const KnowledgeDimensionsPage = Loadable(lazy(() => import('pages/CMS/knowledge/KnowledgeDimensions')));
const KnowledgeDimensionView = Loadable(lazy(() => import('pages/CMS/knowledge/KnowledgeDimensionView')));
const KnowledgeDimensionForm = Loadable(lazy(() => import('pages/CMS/knowledge/KnowledgeDimensionForm')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },

    {
      path: 'accounts',
      element: <Outlet />,
      handle: { breadcrumb: 'Accounts' },
      children: [
        {
          index: true,
          element: <AccountsPage />
        },
        {
          path: 'create',
          element: <AccountForm />,
          handle: { breadcrumb: 'Create' }
        },
        {
          path: ':id',
          element: <AccountView />,
          handle: { breadcrumb: 'View' }
        },
        {
          path: ':id/edit',
          element: <AccountForm />,
          handle: { breadcrumb: 'Edit' }
        }
      ]
    },

    {
      path: 'tenants',
      element: <Outlet />,
      handle: { breadcrumb: 'Tenants' },
      children: [
        {
          index: true,
          element: <TenantsPage />
        },
        {
          path: 'create',
          element: <TenantForm />,
          handle: { breadcrumb: 'Create' }
        },
        {
          path: ':id',
          element: <TenantView />,
          handle: { breadcrumb: 'View' }
        },
        {
          path: ':id/edit',
          element: <TenantForm />,
          handle: { breadcrumb: 'Edit' }
        }
      ]
    },

    {
      path: 'users',
      element: <Outlet />,
      handle: { breadcrumb: 'Users' },
      children: [
        {
          index: true,
          element: <UsersPage />
        },
        {
          path: 'create',
          element: <UserForm />,
          handle: { breadcrumb: 'Create' }
        },
        {
          path: ':id',
          element: <UserView />,
          handle: { breadcrumb: 'View' }
        },
        {
          path: ':id/edit',
          element: <UserForm />,
          handle: { breadcrumb: 'Edit' }
        }
      ]
    },
    {
      path: 'projects',
      element: <Outlet />,
      handle: { breadcrumb: 'Projects' },
      children: [
        {
          index: true,
          element: <ProjectsPage />
        },
        {
          path: 'create',
          element: <ProjectForm />,
          handle: { breadcrumb: 'Create' }
        },
        {
          path: ':id',
          element: <ProjectView />,
          handle: { breadcrumb: 'View' }
        },
        {
          path: ':id/edit',
          element: <ProjectForm />,
          handle: { breadcrumb: 'Edit' }
        }
      ]
    },
    {
      path: 'tests',
      element: <TestsPage />
    },
    {
      path: 'cms',
      element: <Outlet />,
      handle: { breadcrumb: 'CMS' },
      children: [
        {
          index: true,
          element: <CMSPage />
        },
        {
          path: 'knowledge-dimensions',
          element: <Outlet />,
          handle: { breadcrumb: 'Knowledge Dimensions' },
          children: [
            {
              index: true,
              element: <KnowledgeDimensionsPage />
            },
            {
              path: 'create',
              element: <KnowledgeDimensionForm />,
              handle: { breadcrumb: 'Create' }
            },
            {
              path: ':id',
              element: <KnowledgeDimensionView />,
              handle: { breadcrumb: 'View' }
            },
            {
              path: ':id/edit',
              element: <KnowledgeDimensionForm />,
              handle: { breadcrumb: 'Edit' }
            }
          ]
        }
      ]
    }
  ]
};

export default MainRoutes;
